// Autometrics dashboard v3 - master data and parameters (spec section 5).
// Everything here is configuration, not logic: when these move to a database
// table / SharePoint list, swap this module for a fetch and keep the shapes.

export const OTD_TARGET = 85;

export const COLORS = {
  red: '#E2001A',      // Legrand red (hex TBC, spec section 10)
  green: '#3AAA35',    // Enmovil green (hex TBC, spec section 10)
  navy: '#14284b',
  steel: ['#1f3f6e', '#2f5d94', '#4a7bb7', '#7aa1d2', '#a9c3e6', '#d3e1f3'],
  grey: '#8a94a6',
  notDelivered: '#c9d3e1',
};

// Vehicle capacity master - joined on cleaned vehicle type.
export const VEHICLE_CAPACITY = {
  '12 F': { kg: 2000, cbm: 12.2 },
  '14 F': { kg: 3500, cbm: 16.7 },
  '17 F': { kg: 5000, cbm: 22.9 },
  '19 F': { kg: 7000, cbm: 25.6 },
  '20 F': { kg: 6200, cbm: 36.2 },
  '22 F': { kg: 8000, cbm: 39.9 },
  '24 F': { kg: 10000, cbm: 43.5 },
  '32 F 15 MT': { kg: 15000, cbm: 58.0 },
  '32 F 18 MT': { kg: 18000, cbm: 58.0 },
  '32 F 7 MT': { kg: 7000, cbm: 58.0 },
  '32 F 9 MT': { kg: 9000, cbm: 58.0 },
  'BADA DOST': { kg: 1800, cbm: 7.8 },
  'BOLERO': { kg: 1200, cbm: 8.5 },
  'DOST': { kg: 1500, cbm: 7.1 },
  'TATA 407': { kg: 2000, cbm: 12.2 },
  'TATA ACE': { kg: 800, cbm: 5.9 },
};

// Multiply, then divide by 10,00,000.
export const EMISSION_FACTORS = { Road: 137, Rail: 17.2, EV: 10, Air: 1037, CNG: 110 };

export const CO2_GROUPS = {
  Legrand: 'Legrand group', Indoasian: 'Legrand group', Valrack: 'Legrand group',
  Numeric: 'Numeric',
};

// 2024 annual baseline per group.
export const CO2_BASELINE = {
  'Legrand group': { tco2PerTon: 7.1, grossT: 5089 },
  'Numeric': { tco2PerTon: 7.5, grossT: 1685 },
};

// FTL trip weight / CBM source: 'invoices' = sum of the trip's invoice lines
// (consignments collection, as the mobile app does); 'trip' = the trip
// record's own total_weight / total_cbm. Validate against the sign-off
// figure of 11,357 t (spec section 9) and switch if the other one matches.
export const FTL_WEIGHT_SOURCE = 'invoices';

export const DISTANCE_PARAMS = { roadFactor: 1.3, minKm: 15 };

export const SEVERITY_DEFAULTS = {
  minVolume: 30,
  weights: { volume: 30, gap: 25, drop: 15, breach: 15, exceptions: 15 },
};

// POD fields - same rule as the consignments screen (View POD / Upload POD
// icons and the "Pending POD" counter): received when is_submitted_pod = 1,
// which the POD upload sets together with pod_upload_date.
export const POD_FIELDS = {
  status: 'is_submitted_pod',
  receivedDate: 'pod_upload_date',
  receivedValues: ['1', 'true'],
  // 'status' | 'date' - which field is the system of record.
  systemOfRecord: 'status',
};

// The fetched field list lives on the server (FIELDS in
// legrand_node/routes/controller/autometricsController.js) so personal data
// can never be requested from the browser. If POD_FIELDS above changes, add
// the new field names there too.
